import { useParams } from 'react-router-dom';
import BuildingChiller from './Chiller';

/**
 * Building page for an inspection device other than Chiller.
 * Same screen as the building Chiller page. Chiller stays on /buildings/:id/chiller.
 */
export default function BuildingInspectionModule() {
  const { moduleCode: rawCode } = useParams();
  const moduleCode = String(rawCode || '').toUpperCase();
  if (moduleCode === 'CHILLER') {
    return <BuildingChiller moduleCode="CHILLER" />;
  }
  return <BuildingChiller moduleCode={moduleCode} />;
}
